exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".ColourEditor__surround___JNGvW {\n\twidth: 100%;\n\tbackground-color: #eee;\n\tborder-bottom: 0.5rem solid #333;\n}\n\n.ColourEditor__imageSurround___14uZj {\n\tbackground-color: #eee;\n\tdisplay: flex;\n\tposition: relative;\n\tflex-flow: column;\n\talign-items: flex-start;\n\tmin-height: 8rem;\n}\n\n.ColourEditor__uploadedImage___3SUAN {\n\twidth: 100%;\n}\n\n.ColourEditor__fieldSurround___6I8A3 {\n\tpadding: 0 " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + ";\n}\n\n.ColourEditor__buttonSurround___1aVce {\n\tleft: 0;\n    top: 0;\n\tposition: absolute!important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: rgba(255, 255, 255, 0.8);\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + "",
	"surround": "ColourEditor__surround___JNGvW",
	"imageSurround": "ColourEditor__imageSurround___14uZj",
	"uploadedImage": "ColourEditor__uploadedImage___3SUAN",
	"fieldSurround": "ColourEditor__fieldSurround___6I8A3",
	"buttonSurround": "ColourEditor__buttonSurround___1aVce"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ColourEditor.icss
// module id = 1438
// module chunks = 0